<div class="refresh-button" (click)="refresh()">
    <img src="../images/site-icons/renewals-red.svg"  [ngClass]="{'rotate': spinnerRotate }">
    <span >
        &nbsp;&nbsp;Refresh
    </span>
</div>